import { FILTER_RESET } from "./const";

/**
 * action
 *
 * @returns {Object} redux action object
 */
function action() {
  return {
    type: FILTER_RESET,
  };
}

export default action;
